/**
 * Formats Firebase/Callable errors so development builds expose the callable
 * error code + backend message instead of leaving only an opaque HTTP 400 in
 * the browser network panel. Production remains concise for end users.
 */
export function firebaseErrorDetails(error, context='Firebase callable'){
 const rawCode=String(error?.code||error?.name||'').trim();
 const code=rawCode.replace(/^functions\//,'')||'unknown';
 const message=String(error?.message||'').replace(/^Firebase:\s*/,'').trim()||'The server rejected this request.';
 const details=error?.details??null;
 if(process.env.NODE_ENV!=='production'){
  // eslint-disable-next-line no-console
  console.error(`[${context}]`,{code,message,details,error});
 }
 return {code,message,details};
}

export function firebaseErrorMessage(error,fallback='Unable to complete the request.',context='Firebase callable'){
 const info=firebaseErrorDetails(error,context);
 const message=info.message||fallback;
 return process.env.NODE_ENV!=='production'&&info.code&&info.code!=='unknown'?`${message} [${info.code}]`:message;
}
